import services from "../services";
import * as types from "./mutation-type";

export const setItemsWishlist = ({commit}, payload) => {
    commit(types.SET_ITEMS_WISHLIST, payload)
}

export const setPagination = ({commit}, payload) => {
    commit(types.SET_PAGINATION, payload)
}

export const setCountItemsWishlist = ({commit}, payload) => {
    commit(types.SET_COUNT_ITEMS_WISHLIST, payload)
}

export const ActionInsertItemWishList = async ({dispatch}, payload) => {
    await services.insertItemWishList(payload)
    .then(async(response) => {
        let {error, msg} = await response.data
        if(error === true) {
            throw msg
        }
        dispatch('setCountItemsWishlist', response.data.data)
    })
    .catch((error) => { 
        throw error.response
    })
}

export const ActionRemoveItemWishList = async ({dispatch}, payload) => {
    await services.removeItemWishList(payload)
    .then(async(response) => {
        let {error, msg} = await response.data
        if(error === true) {
            throw msg
        }
        dispatch('setCountItemsWishlist', response.data.data)
    })
    .catch((error) => { 
        throw error.response
    })
}

export const ActionGetCountItemsItemsWishlist = ({dispatch}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.getCountItemsWishlist(payload)
        if(data.error === false) {
            dispatch('setCountItemsWishlist', data.data)
            resolve(data)
        }
        reject(data)
    })
}

export const getListPaginate = ({dispatch}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.getListPaginate(payload)
        if(data.error === false) {
            dispatch('setCountItemsWishlist', data.count)
            resolve(data)
        }
        reject(data)
    })
}